import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { pushAutoResubscribe } from './utils/pushAutoResubscribe';

// 🪵 Capteur global d'erreurs (persiste dans localStorage 'nudge_lastCrash' → survit au reload PWA).
// Pour récupérer après un crash : localStorage.getItem('nudge_lastCrash') dans la console.
(() => {
  const save = (type: string, detail: any) => {
    try {
      localStorage.setItem('nudge_lastCrash', JSON.stringify({
        when: new Date().toISOString(), type, url: window.location.href,
        message: String(detail?.message || detail?.reason?.message || detail || '').slice(0, 500),
        stack: String(detail?.error?.stack || detail?.reason?.stack || '').slice(0, 2000),
        ua: navigator.userAgent,
      }));
    } catch { /* ignore */ }
  };
  window.addEventListener('error', (e) => { console.error('[Nudge] window error:', e.error || e.message); save('error', e); });
  window.addEventListener('unhandledrejection', (e) => { console.error('[Nudge] unhandled rejection:', (e as any).reason); save('unhandledrejection', e); });
})();

// Scrollbar Apple-style : visible uniquement pendant le scroll, fade-out après
(() => {
  const timers = new WeakMap<EventTarget, ReturnType<typeof setTimeout>>();
  document.addEventListener('scroll', (e) => {
    const el = (e.target === document ? document.documentElement : e.target) as HTMLElement;
    if (!el?.setAttribute) return;
    el.setAttribute('data-scrolling', '');
    const prev = timers.get(el);
    if (prev) clearTimeout(prev);
    timers.set(el, setTimeout(() => {
      el.removeAttribute('data-scrolling');
      timers.delete(el);
    }, 1200));
  }, true);
})();

// Splash screen : masquer après montage React (minimum 1.5s d'affichage)
const splashStart = Date.now();
function removeSplash() {
  const splash = document.getElementById('nudge-splash');
  if (!splash) return;
  const elapsed = Date.now() - splashStart;
  const remaining = Math.max(0, 1500 - elapsed);
  setTimeout(() => {
    splash.classList.add('splash-hide');
    setTimeout(() => splash.remove(), 500);
  }, remaining);
}

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// Supprimer le splash une fois React monté
removeSplash();

// Register Service Worker for media caching (instant loading after first visit)
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker
      .register('/service-worker.js')
      .then((registration) => {
        console.log('✅ Service Worker registered:', registration.scope);
        // Recrée l'abonnement push si le boot-cleanup l'a détruit au dernier déploiement.
        pushAutoResubscribe();
      })
      .catch((error) => {
        console.error('❌ Service Worker registration failed:', error);
      });
  });
}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
